import type { SxProps, Theme } from "@mui/material";
import { Typography, useTheme } from "@mui/material";

// Brand "new" gradient — not a palette token yet, so this tag owns it.
const NEW_TAG_GRADIENT =
  "linear-gradient(279.75deg, #ED25C1 -8.98%, #DA64ED 47.33%, #A74FFF 66.54%, #874FFF 82.24%, #4D25ED 98.62%)";

interface NewTagProps {
  label?: string;
  sx?: SxProps<Theme>;
}

/** Gradient "New" tag for freshly shipped features (nav items, menus, cards). */
export const NewTag = ({ label = "New", sx }: NewTagProps) => {
  const theme = useTheme();
  return (
    <Typography
      variant="caption-3"
      sx={[
        {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: "16px",
          px: "4px",
          borderRadius: "3px",
          flexShrink: 0,
          color: theme.palette.neutral.main,
          background: NEW_TAG_GRADIENT,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {label}
    </Typography>
  );
};
